import { useState } from 'react'

const useOpenTopicDrawer = () => {
  const [selectedTopic, setSelectedTopic] = useState(null)
  const [show, setShow] = useState(false)

  const openTopic = topic => {
    setSelectedTopic(topic)
    setShow(true)
  }

  const closeTopic = () => {
    setShow(false)
    setSelectedTopic(null)
  }

  return { selectedTopic, show, openTopic, closeTopic }
}

export default useOpenTopicDrawer
